import React, { useState, useEffect, useRef } from 'react';
import { durationPickerType } from 'redux/Types';
import { TextField } from '@material-ui/core';
import clsx from 'clsx';


const DurationPicker = React.forwardRef(({ value,
  classes,
  type = durationPickerType.HHMMSS,
  onChange,
  cueUniqueId = null,
  updateOnBlur = false,
  returnPadded = false,
  disabled = false,
  isDurationSelector = false,
  showLabel = true,
  customLabel = null,
  isInvalidDuration = false,
  durationErrMsg = null,
  setValidTimeCode = null,
  setErrorMessage,
  isInTime = false,
  onClear }, ref) => {
  const isUserInput = useRef(false);
  const [hours, setHours] = useState(getDurationValue("hh", returnPadded) || '');
  const [minutes, setMinutes] = useState(getDurationValue("mm", returnPadded) || '');
  const [seconds, setSeconds] = useState(getDurationValue("ss", returnPadded) || '');
  const [onBlurTriggered, setOnBlurTriggered] = useState(false);
  const [error, setError] = useState('');
  const [hoursTitle, setHoursTitle] = useState('');
  const [minutesTitle, setMinutesTitle] = useState('');
  const [secondsTitle, setSecondsTitle] = useState('');
  useEffect(() => {
    if (onClear) {
      setHours('');
      setMinutes('');
      setSeconds('');
    }
  }, [onClear]);

  useEffect(() => {

    if (isUserInput.current) {
      setTimeout(() => {
        isUserInput.current = false;
      }, 1000)
      // isUserInput.current = false; // reset it
      return;
    }
    if (value !== undefined && value !== null && value !== '') {
      const hh = getDurationValue("hh", returnPadded) || '';
      const mm = getDurationValue("mm", returnPadded) || '';
      const ss = getDurationValue("ss", returnPadded) || '';

      setHours(hh);
      setMinutes(mm);
      setSeconds(ss);
    }
  }, [value]); // ✅ depends on timecode (in seconds)


  useEffect(() => {
    if (onChange) {
      let dur = ""
      switch (type) {
        case durationPickerType.SS:
          if (seconds) {
            dur = seconds;
          } else { return; }
          break;

        case durationPickerType.MMSS:
          if (minutes || seconds) {
            dur = (minutes ? minutes * 60 : 0) + (seconds ? seconds : 0);
          } else { return; }
          break;

        case durationPickerType.HHMMSS:
        default:
          if (hours || minutes || seconds) {
            dur = (hours ? Number(hours) * 3600 : 0) + (minutes ? Number(minutes) * 60 : 0) + (seconds ? Number(seconds) : 0);
          } else { return; }
          break;
      }


      if (!updateOnBlur) {
        onChange(dur);
      } else {
        // console.log("================> DUR useffect 1: ", value, onBlurTriggered)

        if (onBlurTriggered) {
          if (isDurationSelector && (((hours || hours == 0) && hours !== "") && ((minutes || minutes == 0) && minutes !== "") && ((seconds || seconds == 0) && seconds !== ""))) {
            if (setValidTimeCode) {
              setValidTimeCode(true);
            }
            onChange(dur);
            setOnBlurTriggered(false);
          }
          else if (!isDurationSelector) {
            onChange(dur);
            setOnBlurTriggered(false);
          }
        }

      }
    }
  }, [hours, minutes, seconds, onBlurTriggered]);

  function getDurationValue(dType = "hh", returnPadded = false) { // converting received "value" of seconds to hh:mm:ss and return the prefered value
    const seconds = value;
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const paddedHours = String(hours).padStart(2, '0');
    const paddedMinutes = String(minutes).padStart(2, '0');
    const paddedSeconds = String(remainingSeconds).padStart(2, '0');

    const shouldPad = returnPadded && !isUserInput.current;
    switch (dType) {
      case "ss":
        if (value && returnPadded && shouldPad) {
          return (paddedSeconds);
        }
        else if (isInTime && value === 0 && returnPadded && shouldPad) {
          return ("00");
        }
        else if (value && returnPadded && !shouldPad) {
          return (remainingSeconds);
        }
        else {
          return (remainingSeconds);
        }
      // return (paddedSeconds);
      case "mm":
        if (value && returnPadded) {
          return (paddedMinutes);
        }
        else if (isInTime && value === 0 && returnPadded && shouldPad) {
          return ("00");
        }
        else {
          return (minutes);
        }
      // return (paddedMinutes);
      case "hh":
      default:
        if (value && returnPadded) {
          return (paddedHours);
        }
        else if (isInTime && value === 0 && returnPadded && shouldPad) {
          return ("00");
        }
        else if (value == "" && returnPadded) {
          return ("");
        }
        else {
          return (hours);
        }

      // return (paddedHours);
    }

  }


  const handleHoursChange = (event) => {
    let value = event.target.value;
    isUserInput.current = true;
    if (event.target.value == "") {
      setHours("");
      validateDuration(null, minutes, seconds);
      setHoursTitle(event.target.value.substring(0, 2));
      setOnBlurTriggered(true);
    }
    else {
      value = value.slice(0, 2); // max character lenth allowed in old sky is 2 
      if (Number(value) > 23) {
        return;
      }
      value = Number(value);

      setHours(value);
      setHoursTitle(event.target.value.substring(0, 2));
      validateDuration(value, minutes, seconds);

      if (event.target.value.toString().length === 2) {
        const input = document.getElementById(cueUniqueId ? `${cueUniqueId}_minutes` : "minutes");
        input.focus();
        setOnBlurTriggered(true);
      }
    }

  };

  const handleMinutesChange = (event) => {
    let value = event.target.value;
    isUserInput.current = true;
    if (event.target.value == "") {
      setMinutes("");
      validateDuration(hours, null, seconds);
      setMinutesTitle(event.target.value.substring(0, 2));
      setOnBlurTriggered(true);
    }
    else {
      if (type === durationPickerType.HHMMSS || type === durationPickerType.HHMM) {
        value = value.slice(0, 2);
        if (Number(value) > 59) {
          return;
        }
      } else {
        value = value.slice(0, 3); // max character lenth allowed in old sky is 3 for mm:ss input
      }
      value = Number(value);
      setMinutes(isDurationSelector && event.target.value.includes("000") ? "00" : value);
      setMinutesTitle(event.target.value.substring(0, 2));
      validateDuration(hours, value, seconds);
      if (event.target.value.toString().length === 2) {
        const input = document.getElementById(cueUniqueId ? `${cueUniqueId}_seconds` : "seconds");
        input.focus();
        setOnBlurTriggered(true);
      }
    }

  };

  const handleSecondsChange = (event) => {
    let value = event.target.value;
    isUserInput.current = true;
    if (event.target.value == "") {
      setSeconds("");
      validateDuration(hours, minutes, null);
      setSecondsTitle(event.target.value.substring(0, 2));
      setOnBlurTriggered(true);
    }
    else {
      if (type === durationPickerType.HHMMSS || type === durationPickerType.MMSS) {
        value = value.slice(0, 2);
        if (Number(value) > 59) {
          return;
        }
      } else {
        value = value.slice(0, 3); // max character length setted as the minutes.
      }
      value = Number(value);
      setSeconds(value);
      setSecondsTitle(event.target.value.substring(0, 2))
      validateDuration(hours, minutes, value);
      if (isDurationSelector) {
        if (event.target.id.includes("in") && event.target.value.toString().length === 2) {
          let focusElement = cueUniqueId.replace("in", "out");
          const input = document.getElementById(focusElement ? `${focusElement}_hours` : null);
          if(input){
            input.focus();
          }
          
        }
        setOnBlurTriggered(true);
      }
    }

  };


  const validateDuration = (hours, minutes, seconds) => {
    switch (type) {
      case durationPickerType.HHMMSS:
        if ((!isDurationSelector && !hours) || hours < 0 || hours > 23 || (!isDurationSelector && !minutes) || minutes < 0 || minutes > 59 || (!isDurationSelector && !seconds) || seconds < 0 || seconds > 59) {
          setError('Invalid duration. Please enter a valid value. HHMMSS');
        }
        else if (hours === 0 && minutes === 0 && seconds === 0) {
          if (isDurationSelector && setErrorMessage && !isInTime) {
            setErrorMessage(true, 'Duration cannot be zero. Please enter a valid value.');
          }
          else {
            setError('Duration cannot be zero. Please enter a valid value.');
          }

        } else if ((isDurationSelector && !hours) || (isDurationSelector && !minutes) || (isDurationSelector && !seconds)) {
          if (setErrorMessage) {
            setErrorMessage(true, 'All time code values should be filled.');
          }

        } else if (isDurationSelector && ((hours || hours == 0) && (minutes || minutes == 0) && (seconds || seconds == 0))) {
          if (setValidTimeCode) {
            setValidTimeCode(true);
          }

        } else {
          setError('');
        }
        break;
      case durationPickerType.MMSS:
        if (minutes < 0 || seconds < 0 || seconds > 59) {
          setError('Invalid duration. Please enter a valid value.');
        } else {
          setError('');
        }

        break;
      case durationPickerType.SS:
        if (seconds < 0) {
          setError('Invalid duration. Please enter a valid value.');
        } else {
          setError('');
        }

        break;

      default:
        if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59 || seconds < 0 || seconds > 59) {
          setError('Invalid duration. Please enter a valid value.');
        } else {
          setError('');
        }
        break;
    }

  };

  const clearValues = () => {
    setHours('');
    setMinutes('');
    setSeconds('');
    setError(''); // Clear any validation errors
    setOnBlurTriggered(false);
    // if (onChange) {
    //   onChange(0); // ← reset timecode in parent
    // }
  }


  React.useImperativeHandle(ref, () => ({
    clearValues,
  }));
  return (
    <div className={clsx(classes.durationPicker, "MainDurationContainer")}>
      {isDurationSelector && customLabel && (`${customLabel}`)}
      {(type === durationPickerType.HHMMSS || type === durationPickerType.HHMM) &&
        <>
          <div className={classes.durationSpan}>
            {showLabel && (<label> HH</label>)}

            <TextField
              type="number"
              id={cueUniqueId ? `${cueUniqueId}_hours` : "hours"}
              value={hours}
              title={hoursTitle}
              placeholder='HH'
              variant='outlined'
              error={isInvalidDuration && durationErrMsg ? true : false}
              className={classes.durationInputter}
              onChange={handleHoursChange}
              disabled={disabled || false}
              onFocus={(e) => e.preventDefault()}
              onBlur={(event) => {

                if (hours) {
                  setOnBlurTriggered(true);
                }
                else if (isDurationSelector && (event.target.value === "0" || event.target.value === "00")) {
                  setHours(event.target.value);
                  setOnBlurTriggered(true);
                }
              }}
              inputProps={{
                min: 0,
                max: 23,
                pattern: "[0-9]*"
              }}
            />
          </div>

        </>
      }
      {(type === durationPickerType.HHMMSS || type === durationPickerType.HHMM || type === durationPickerType.MMSS) &&
        <>
          <div className={classes.durationSpan}>
            {showLabel && (<label> MM </label>)}
            <TextField
              type="number"
              variant='outlined'
              id={cueUniqueId ? `${cueUniqueId}_minutes` : "minutes"}
              value={minutes}
              placeholder='MM'
              title={minutesTitle}
              error={isInvalidDuration && durationErrMsg ? true : false}
              className={classes.durationInputter}
              onChange={handleMinutesChange}
              disabled={disabled || false}
              onBlur={(event) => {

                if (minutes) {
                  setOnBlurTriggered(true);
                }
                else if (isDurationSelector && (event.target.value === "0" || event.target.value === "00")) {
                  setMinutes(event.target.value);
                  setOnBlurTriggered(true);
                }
              }}
              onFocus={() => {
                // console.log("========== MM ONFocucs")
              }}
              onFocusCapture={() => {
                setOnBlurTriggered(false);
                // console.log("========== MM onFocusCapture")
              }}
              inputProps={{
                min: 0,
                max: type === durationPickerType.HHMMSS ? 59 : null,
                pattern: "[0-9]*"
              }}
            />
          </div>

        </>
      }
      {(type === durationPickerType.HHMMSS || type === durationPickerType.MMSS || type === durationPickerType.SS) &&
        <>
          <div className={classes.durationSpan}>
            {showLabel && (<label> SS </label>)}
            <TextField
              type="number"
              value={seconds}
              title={secondsTitle}
              error={isInvalidDuration && durationErrMsg ? true : false}
              placeholder='SS'
              id={cueUniqueId ? `${cueUniqueId}_seconds` : "seconds"}
              variant='outlined'
              onChange={handleSecondsChange}
              className={classes.durationInputter}
              disabled={disabled || false}
              onBlur={(event) => {
                if (seconds) {
                  setOnBlurTriggered(true)
                } else if (isDurationSelector && (event.target.value === "0" || event.target.value === "00")) {
                  setSeconds(event.target.value);
                  setOnBlurTriggered(true);
                }
              }}
              onFocusCapture={() => {
                setOnBlurTriggered(false);
                // console.log("========== SS onFocusCapture")
              }}
              inputProps={{
                min: 0,
                max: (type === durationPickerType.HHMMSS || type === durationPickerType.MMSS) ? 59 : null,
                pattern: "[0-9]*"
              }}
            />
          </div>


        </>
      }

      {/* {error && <p>{error}</p>} */}

    </div>
  );
});

export default DurationPicker;
